var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed bottom-0 right-0 w-87 flex justify-center items-center z-10 mr-3 mb-6 cursor-pointer",on:{"click":function($event){return _vm.moveTo(1)}}},[_c('img',{attrs:{"src":(_vm.imgPath + "/slide1/top_btn.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }